import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Col, Row, Button } from 'reactstrap';
import BranchTable from './BranchTable';
import { addBranch, getBranches } from 'store/actions';
import CreateBranch from './CreateBranch';
import Breadcrumb from 'components/Common/Breadcrumb2';

const BranchList = () => {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();

    const dispatch = useDispatch();
    const branches = useSelector((state) => state.Branch.branches);
    const loading = useSelector((state) => state.Branch.loading);
    const error = useSelector((state) => state.Branch.error);

    const permissions = JSON.parse(localStorage?.getItem('permissions'));

    // Dispatch action to fetch branches when the component mounts
    useEffect(() => {
        if (loading) return;
        dispatch(getBranches()); // Dispatch the action to fetch branches
    }, [dispatch]);

    const handleSubmit = (data) => {
        dispatch(addBranch(data));
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    return (
        <>
            <CreateBranch visible={isOpen} onSubmit={handleSubmit} handleClose={handleClose} />
            <div className="page-content container-fluid">
                <div className="d-flex justify-content-between align-items-center mx-3">
                    <Breadcrumb
                        title="Branches"
                        breadcrumbItems={[
                            { title: "Dashboard", link: `/dashboard` },
                            { title: "Branches", link: '#' },
                        ]}
                    />
                    {permissions?.map(item => item?.permissionName)?.includes("Add Branch") && (
                        <Button
                            className="bg-primary text-white d-flex justify-content-center gap-1 align-items-center"
                            onClick={() => setIsOpen(true)}
                        >
                            <i className="ti-plus"></i> Add New
                        </Button>
                    )}
                </div>

                <BranchTable loading={loading} List={branches?.Data} />
            </div>
        </>
    );
};

export default BranchList;